export default __webpack_public_path__ + "images/0xa3d1a8deb97b111454b294e2324efad13a9d8396.png";